import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { UserOutlined } from '@ant-design/icons'
import {Menu, Dropdown, Avatar, Badge, message} from 'antd'
import styles from './style.module.scss'
import { useAuth0 } from '@auth0/auth0-react'
import { PUBLIC_URL } from '../../../../../constants/Config'
import {isCollectAnalytics, isIframe} from '../../../../../services/utils'
import { useData } from '../../../../../contexts/data-context'
import {accountService} from "../../../../../services/api/account.service";
import { getAccountRole, isOwnerRole } from '../../../../../services/role'

const ProfileMenu = () => {
  const [count, setCount] = useState(7)
  const { logout, user, getAccessTokenSilently } = useAuth0()
  const history = useHistory()
  const { default_dataset, init_status, product, is_customer } = useData()

  useEffect(() => {
    if (!isIframe() && isCollectAnalytics(product) && user && window.amplitude && window.amplitude.setUserId && window.amplitude.Identify) {
      window.amplitude.setUserId(user.sub)
      const identifyEvent = new window.amplitude.Identify();
      identifyEvent.set('email', user.email);
      identifyEvent.set('name', user.name);
      identifyEvent.set('status', init_status);
      identifyEvent.set('is_customer', is_customer);
      identifyEvent.set('product', product);
      window.amplitude.identify(identifyEvent);
    }
  }, [user, window.amplitude])

  const do_logout = e => {
    e.preventDefault()
    logout({ returnTo: PUBLIC_URL })
  }

  const go_to_connect = e => {
    e.preventDefault()
    history.push('/init/connect')
  }

  const addCount = () => {
    setCount(count + 1)
  }

  const openBillingPortal = () => {
    ;(async () => {
      try {
        const token = await getAccessTokenSilently()
        const {url} = await accountService.getBillingPortalUrl(token, product)
        window.open(url, '_blank');
      }
      catch (e) {
        console.error(e)
        message.error("Something went wrong. Please try again later or contact us at support@swifteq.com.", 10)
      }
    })()
  }

  const user_role = getAccountRole(user)
  const is_user_owner = isOwnerRole(user)
  const is_user_admin = user_role === 'admin'

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <strong>Hello, {(user || {}).name || 'Anonymous'}</strong>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <div>
          <strong>Email: </strong>
          {(user || {}).email || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={go_to_connect}>
          <i className="fe fe-airplay mr-2" />
          Helpdesk Authorization
        </a>
      </Menu.Item>
      {is_user_owner &&
        <Menu.Item disabled={!is_user_owner}
                   title={(!is_user_owner) ? 'Only an Owner can invite other users' : ''}>
          <a onClick={() => history.push('/invite-users')}>
            <i className="fe fe-users mr-2"/>
            Invite Users
          </a>
        </Menu.Item>}
      {(product === 'mergedup' ||
        product === 'redact' ||
        product === 'attachments' ||
        product === 'triggers_gpt' ||
        product === 'lookup' ||
        product === 'translate' ||
        product === 'cowriter' ||
        product === 'removecc') && is_customer && (
          <Menu.Item>
            <a onClick={openBillingPortal} target="_blank">
              <i className="fe fe-credit-card mr-2" />
              Manage Billing
            </a>
          </Menu.Item>
        )}
      {is_user_admin &&
      <Menu.Item>
        <a href="#" onClick={() => window.location.href = '/?product=admin'}>
          <i className="fe fe-airplay mr-2" />
          Admin Dashboard
        </a>
      </Menu.Item>}
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={do_logout}>
          <i className="fe fe-log-out mr-2" />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} onVisibleChange={addCount}>
      <div className={styles.dropdown}>
        <Avatar className={styles.avatar} shape="square" size="large" icon={<UserOutlined />} />
      </div>
    </Dropdown>
  )
}

export default ProfileMenu
